import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useFormikContext} from "formik";
import FormikInput from "../../../../../../components/input/new/FormikInput";

SenderCountryCode.propTypes = {

};

function SenderCountryCode() {
    const {values, setFieldValue} = useFormikContext();

    useEffect(() => {
        if (values.senderCountryCode) {
            const upper = values.senderCountryCode.toUpperCase();
            if (upper !== values.senderCountryCode) {
                setFieldValue('senderCountryCode', upper);
            }
        }
    }, [values.senderCountryCode]);

    return (
        <FormikInput
            name={"senderCountryCode"}
            label={"shippingMethods.form.field.senderCountryCode.label"}
            placeholder={"shippingMethods.form.field.senderCountryCode.placeholder"}
            required={true}
        />
    );
}

export default SenderCountryCode;